module.exports = __webpack_public_path__ + "static/img/kefu.43ba1c0.png";


//////////////////
// WEBPACK FOOTER
// ./static/kefu.png
// module id = /w03
// module chunks = 1